    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center">
                        <h1 class="page-heading"><svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_651_309)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_651_309" x="0" y="0" width="42" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_651_309"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_651_309" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            
                            
                            Evaluation
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">Evaluation</li>
                            <!--end::Item-->
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
            <div id="kt_app_content" class="app-content flex-column-fluid mb-15">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card pb-10 pt-10">
                        <!--begin::Card header-->

                    <div class="container">
                        <div class="card-body tools">
                            <div class="title">
                             <h4>Quiz</h4>
                            </div>
                        <div class="bouton">
                         <a href="#" class="add-question" data-bs-toggle="modal" data-bs-target="#add-question">Ajouter une question</a>
                        </div>
                           
                           </div>


                           <div class="questions">
                            <div class="item mb-10">
                                <div class="item-header">
                                    <div class="left">
                                        <span class="number">1</span>
                                        <h4>Lequel des énoncés suivants est correct à propos de JDBC? </h4>
                                    </div>
                                    <div class="right">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_142_1063)">
                                            <path d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z" fill="#265D91"/>
                                            </g>
                                            <defs>
                                            <filter id="filter0_d_142_1063" x="0" y="0" width="26" height="25.8924" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                            <feOffset dy="4"/>
                                            <feGaussianBlur stdDeviation="2"/>
                                            <feComposite in2="hardAlpha" operator="out"/>
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_142_1063"/>
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_142_1063" result="shape"/>
                                            </filter>
                                            </defs>
                                            </svg>
                
                                    </div>
                                </div>
                                <div class="item-content">
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                De nouveaux pilotes peuvent être connectés à l’API JDBC sans changer le code client.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                L’API JDBC fournit l’abstraction et les pilotes JDBC fournissent l’implémentation.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Les deux A et B sont vrais.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" checked="checked"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Aucune de ces réponses n’est vraie.
                                            </label>
                                        </div>
                                    </div>
                                </div>
                               </div>
                               <div class="item mb-10">
                                <div class="item-header">
                                    <div class="left">
                                        <span class="number">1</span>
                                        <h4>Lequel des énoncés suivants est correct à propos de JDBC? </h4>
                                    </div>
                                    <div class="right">
                                        <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g filter="url(#filter0_d_142_1063)">
                                            <path d="M4 15.6558V5.59137C4 4.9982 4.23707 4.42933 4.65906 4.00989C5.08106 3.59046 5.6534 3.35482 6.25019 3.35482H13.1301L10.9165 5.59137H6.25019V15.6558H16.376V11.0206L18.6262 8.82039V15.6558C18.6262 16.249 18.3891 16.8179 17.9671 17.2373C17.5451 17.6567 16.9728 17.8924 16.376 17.8924H6.25019C5.6534 17.8924 5.08106 17.6567 4.65906 17.2373C4.23707 16.8179 4 16.249 4 15.6558ZM20.3138 0C19.8664 0.000391512 19.4374 0.177375 19.1212 0.492041L11.1246 8.56878C10.8786 8.8174 10.6929 9.11861 10.5818 9.44942L9.77173 11.8677C9.76161 11.9064 9.76183 11.947 9.77238 11.9855C9.78293 12.0241 9.80343 12.0592 9.83185 12.0875C9.86028 12.1157 9.89564 12.1361 9.93443 12.1466C9.97322 12.1571 10.0141 12.1573 10.053 12.1473L12.4944 11.3505C12.8273 11.2401 13.1304 11.0556 13.3805 10.8109L21.5064 2.86278C21.7422 2.6282 21.9027 2.32944 21.9677 2.00425C22.0326 1.67906 21.9992 1.34202 21.8716 1.03569C21.744 0.729368 21.5279 0.4675 21.2507 0.283164C20.9734 0.098828 20.6474 0.000291618 20.3138 0Z" fill="#265D91"/>
                                            </g>
                                            <defs>
                                            <filter id="filter0_d_142_1063" x="0" y="0" width="26" height="25.8924" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                                            <feOffset dy="4"/>
                                            <feGaussianBlur stdDeviation="2"/>
                                            <feComposite in2="hardAlpha" operator="out"/>
                                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_142_1063"/>
                                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_142_1063" result="shape"/>
                                            </filter>
                                            </defs>
                                            </svg>
                
                                    </div>
                                </div>
                                <div class="item-content">
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                De nouveaux pilotes peuvent être connectés à l’API JDBC sans changer le code client.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                L’API JDBC fournit l’abstraction et les pilotes JDBC fournissent l’implémentation.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Les deux A et B sont vrais.
                                            </label>
                                        </div>
                                    </div>
                                    <div class="question">
                                        <div class="form-check form-check-custom form-check-solid">
                                            <input class="form-check-input" type="checkbox" value="1" id="flexCheckDefault" checked="checked"/>
                                            <label class="form-check-label" for="flexCheckDefault">
                                                Aucune de ces réponses n’est vraie.
                                            </label>
                                        </div>
                                    </div>
                                </div>
                               </div>
                        </div>


                    </div>

                
                    </div>

                </div>
                <!--end::Content container-->
            </div>
            <!--begin::Content-->

         
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>
    <script src="./assets/js/custom/apps/projects/settings/settings.js"></script>
    <script src="./assets/js/widgets.bundle.js"></script>
    <script src="./assets/js/custom/widgets.js"></script>
    <script src="./assets/js/custom/apps/chat/chat.js"></script>
    <script src="./assets/js/custom/apps/ecommerce/customers/listing/listing.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/add.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/export.js"></script>
        <div class="modal fade" tabindex="-1" id="add-question">
			<div class="modal-dialog modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h3 class="modal-title">Ajouter question</h3>

						<!--begin::Close-->
						<div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
							<i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
						</div>
						<!--end::Close-->
					</div>

					<div class="modal-body">
						<form id="kt_customers_export_form" class="form" action="#">
							<!--begin::Input group-->
							<div class="fv-row mb-5">
								<!--begin::Label-->
								<div class="mb-5">
									<label for="question" class="required form-label">Ajouter une question</label>
									<input type="text" class="form-control mb-3" placeholder="question"/>
								</div>
								</div>
								</form>

					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-primary" data-bs-stacked-modal="#kt_modal_stacked_2" >Confirmer</button>
					</div>
				</div>
			</div>
			</div>

			<div class="modal fade" tabindex="-1" id="kt_modal_stacked_2">
			<div class="modal-dialog modal-dialog-centered modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h3 class="modal-title">Ajouter question</h3>

						<!--begin::Close-->
						<div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
							<i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
						</div>
						<!--end::Close-->
					</div>

					<div class="modal-body">
						<form id="kt_customers_export_form" class="form" action="#">
							<!--begin::Input group-->
							<div class="fv-row mb-5">
								<!--begin::Label-->
								<div class="mb-5">
									<label for="question" class="required form-label">Question N° 1 :</label>
									<input type="text" class="form-control mb-3" placeholder="question"/>
								</div>
								<div class="mb-5">
									<label for="réponse" class="required form-label">Ajouter une réponse</label>
									<input type="text" class="form-control mb-3" placeholder="réponse"/>
								</div>
								</div>
								</form>


					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-bs-dismiss="modal">Annuler</button>
						<button type="button" class="btn btn-primary" data-bs-stacked-modal="#kt_modal_stacked_3">Confirmer</button>
					</div>
				</div>
			</div>
			</div>

			<div class="modal fade" tabindex="-1" id="kt_modal_stacked_3" data-bs-backdrop="static">
			<div class="modal-dialog modal-dialog-centered modal-lg">
				<div class="modal-content">
					<div class="modal-header">
						<h3 class="modal-title">Stacked modal title</h3>

						<!--begin::Close-->
						<div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
							<i class="ki-duotone ki-cross fs-1"><span class="path1"></span><span class="path2"></span></i>
						</div>
						<!--end::Close-->
					</div>

					<div class="modal-body">
						<form id="kt_customers_export_form" class="form" action="#">
							<!--begin::Input group-->
							<div class="fv-row mb-5">
								<!--begin::Label-->
								<div class="mb-5">
									<label for="Réponse" class="required form-label">Réponse N° 1 :</label>
									<input type="text" class="form-control mb-3" placeholder="Réponse"/>
								</div>

								</div>
								</form>

					</div>

					<div class="modal-footer">
						<button type="button" class="btn btn-light" data-bs-dismiss="modal">Annuler</button>
						<button type="button" class="btn btn-primary">Confirmer</button>
					</div>
				</div>
			</div>
			</div>